<template>
  <vf-toggletip>
    <template #trigger>
      <slot name="promo" :text>
        <span class="text-left i-block overflow-wrap-anywhere">
          <base-interpolator v-if="showTitle" :content="$t.promo">
            <template #uppercase="{ args: [message] }">
              <span class="uppercase">{{ message }}</span>
            </template>
          </base-interpolator>
          <span v-if="showTitle">:</span>
          {{ text }}
          <vf-icon class="i-block" name="info" style="margin-bottom: -0.2rem" />
        </span>
      </slot>
    </template>
    <form-legal-disclaimer :content="callout" />
  </vf-toggletip>
</template>

<script lang="ts" setup>
const { id, details = '' } = defineProps<{
  id?: string
  text?: string
  details?: string
  showTitle?: boolean
}>()

const { get: getApproachingPromos, splitMessages } = useApproachingPromotionsStore()

const callout = computed(() => {
  if (id && getApproachingPromos().some((promo) => promo.id === id && promo.thresholdStatus === 'Threshold Reached')) {
    return splitMessages(details)[2] || details
  }

  return details
})
</script>
